import React from 'react'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'

import { WPCF7Form } from '@/types'

export type MultiChoiceFieldProps = {
  field: WPCF7Form['form'][0]
  formik: any
}

const MultiChoiceField = ({ field, formik }: MultiChoiceFieldProps) => {
  const handleChange = (choiceValue: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentValues = formik.values[`input_${field.id}`] || []
    let newValues: string[]

    if (event.target.checked) {
      // Aggiungi il valore se non è già presente
      newValues = [...currentValues, choiceValue]
    } else {
      // Rimuovi il valore
      newValues = currentValues.filter((value: string) => value !== choiceValue)
    }

    formik.setFieldValue(`input_${field.id}`, newValues)
  }

  const selectedValues = formik.values[`input_${field.id}`] || []

  return (
    <>
      {field.label && field.labelPlacement !== 'hidden_label' && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: 'block',
            mb: 2,
            ...(formik.submitCount > 0 &&
              formik.errors[`input_${field.id}`] !== undefined &&
              formik.touched[`input_${field.id}`] !== undefined && {
                color: 'error.main'
              })
          }}
        >
          {field.label}
          {field.isRequired ? ' *' : ''}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          ...(formik.isSubmitting && {
            pointerEvents: 'none',
            opacity: 0.4
          })
        }}
      >
        {field.choices?.map((choice) => (
          <FormControlLabel
            key={choice.value}
            control={
              <Checkbox
                checked={selectedValues.includes(choice.value)}
                onChange={handleChange(choice.value)}
                disabled={formik.isSubmitting}
                sx={{
                  py: '4px',
                  pr: 0
                }}
                disableRipple
                icon={
                  <Box
                    sx={(theme) => ({
                      width: '1.6rem',
                      height: '1.6rem',
                      backgroundColor: 'transparent',
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: theme.shape.borderRadius1
                    })}
                  ></Box>
                }
                checkedIcon={
                  <Box
                    sx={(theme) => ({
                      width: '1.6rem',
                      height: '1.6rem',
                      backgroundColor: 'transparent',
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: theme.shape.borderRadius1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    })}
                  >
                    <Box
                      sx={(theme) => ({
                        width: '1rem',
                        height: '1rem',
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: '2px'
                      })}
                    ></Box>
                  </Box>
                }
              />
            }
            label={
              <Typography
                variant="textRegular"
                color="text.secondaryContrastText"
                sx={{
                  ml: 2,
                  ...(formik.submitCount > 0 &&
                    formik.errors[`input_${field.id}`] !== undefined &&
                    formik.touched[`input_${field.id}`] !== undefined && {
                      color: 'error.main'
                    })
                }}
              >
                {choice.text}
              </Typography>
            }
            sx={{
              alignItems: 'flex-start',
              m: 0
            }}
          />
        ))}
      </Box>
      {formik.submitCount > 0 &&
        formik.touched[`input_${field.id}`] &&
        formik.errors[`input_${field.id}`] && (
          <Typography variant="caption" color="error" sx={{ mt: 1 }}>
            {String(formik.errors[`input_${field.id}`])}
          </Typography>
        )}
    </>
  )
}

export default MultiChoiceField
